import App from '@/models/App'
import i18n from '@/plugins/i18n'

export default class ShipUser extends App {
    static get entity() {
        return 'ShipUsers'
    }
    static all() {
        return this.query().get()
    }
    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }
    static fetchByShipId(shipId) {
        return this.query()
            .where('shipId', shipId)
            .withAllRecursive()
            .orderBy('id', 'desc')
            .get()
    }
    static fetchByUserId(userId) {
        return this.query()
            .get()
            .filter((user) => user.userId === userId)
    }
    static fields() {
        return {
            id: this.attr(''),
            shipId: this.attr(''),
            userId: this.attr(''),
            maritimeId: this.attr(''),
            firstName: this.attr(''),
            middleName: this.attr(''),
            lastName: this.attr(''),
            job: this.attr(''),
            email: this.attr(''),
            profileImage: this.attr(''),
            laborPrivilegeId: this.attr(''),
        }
    }
    get anyMiddleName() {
        return this.middleName ?? ''
    }
    get fullName() {
        return i18n.locale === 'ja'
            ? `${this.lastName} ${this.anyMiddleName} ${this.firstName}`
            : `${this.firstName} ${this.anyMiddleName} ${this.lastName}`
    }
    static apiConfig = {
        actions: {
            fetch(shipId, params = {}) {
                return this.get(`${shipId}/invites`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            fuzzy(shipId, params) {
                return this.get(`${shipId}/invites/fuzzy`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            create(shipId, userId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.post(
                    `${shipId}/invites/${userId}`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'shipUser',
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(shipId, shipUserId) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.delete(`${shipId}/invites/${shipUserId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    delete: shipUserId,
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
